import { array, boolean, object, string, enum as zEnum } from "zod";

export const setIDFShippingIntegration = {
  name: "setIDFShippingIntegration" as const,
  input: object({
    clientId: string(),
    clientSecret: string().optional(),
    tenantId: string(),
    mode: zEnum(["test", "production"]),
    carrierBlacklist: array(string()).optional(),
  }),
  output: object({ success: boolean() }),
};
